/**
 * Demo tenant / demo account detection helpers.
 *
 * Kept ultra-simple: a single email allowlist + brand-name check so any
 * component can decide whether to render the "Demo Environment" badge,
 * disable a destructive button, or filter Eva suggestions.
 */

const DEMO_EMAILS = new Set([
  'demo-biz@getrestaff.co',
  'demo-staff@getrestaff.co',
]);

const DEMO_BRAND_NAME = 'SparkleClean Solutions';

/** True if the given user object belongs to the public demo. */
export function isDemoUser(user) {
  if (!user) return false;
  if (user.email && DEMO_EMAILS.has(String(user.email).toLowerCase())) return true;
  if (user.brand_name === DEMO_BRAND_NAME) return true;
  return false;
}

/** True if the current tenant (restaurant group) is the demo tenant. */
export function isDemoTenant(group) {
  return !!(group && group.brand_name === DEMO_BRAND_NAME);
}

export const DEMO_LOCKED_MESSAGE = 'Demo environment is view-only.';
